'use es6';

import { List, Record } from 'immutable';
export default Record({
  answerSubmissions: List(),
  attemptStartTime: null,
  attemptFinishTime: null,
  id: null,
  passed: false,
  portalId: null,
  quizId: null,
  userId: null,
  isRequesting: false,
  hasError: false
}, 'Attempt');